// Снимки экранов для сверки с первой версией: параметры после # — какой экран, тема, окно (как в первой версии):
// #tab=sched&mode=month&theme=dark&go=client&id=c3&sheet=color&at=2026-09-22T08:20.
// Номера первой версии («c3», «s13», «p1») переводятся в номера базы так же, как при переносе данных (importV1).
import { STATUS, addDays, findConflicts } from '@praktika/core';
import { applyTheme, phrase, PHRASES } from './lib/theme.ts';
import { testClock } from './lib/api.ts';
import { colorSheet } from './lib/colors.ts';
import { go, render, setTab } from './lib/nav.ts';
import { S, UI } from './lib/state.ts';
import { zonesSheet } from './lib/zones.ts';
import { shotAt } from './shotClock.ts';

declare global { interface Window { __shotDone?: boolean } }

// ключ переноса подменных данных первой версии (tools/shots-db.ts)
const IMPORT_KEY = 'mock';

export const shotParams: Record<string, string> | null = shotAt ? Object.fromEntries(decodeURIComponent(
  location.hash.slice(1)).split('&').map((kv) => { const a = kv.split('='); return [a[0]!, a.slice(1).join('=')]; })) : null;
if (shotAt) testClock.now = shotAt;

// тот же uuid, что legacyUuid на сервере
async function legacyUuid(kind: string, id: string): Promise<string> {
  const buf = await crypto.subtle.digest('SHA-1', new TextEncoder().encode('praktika-v1|' + IMPORT_KEY + '|' + kind + '|' + id));
  const h = Array.from(new Uint8Array(buf), (b) => b.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-5${h.slice(13, 16)}-${((parseInt(h[16]!, 16) & 3) | 8).toString(16)}` +
    `${h.slice(17, 20)}-${h.slice(20, 32)}`;
}

const KIND_OF: Record<string, string> = { client: 'client', group: 'group', move: 'session', editSession: 'session' };

export async function shotApply(p: Record<string, string>): Promise<void> {
  phrase.text = PHRASES[0]!;
  if (p.name) S.settings.user_name = p.name;
  if (p.bg) S.settings[p.theme === 'dark' ? 'bg_dark' : 'bg_light'] = '#' + p.bg;
  if (p.cp) S.settings.color_personal = p.cp;
  if (p.cpr) S.settings.color_project = p.cpr;
  if (p.theme) { S.settings.theme = p.theme as typeof S.settings.theme; applyTheme(p.theme); }
  if (p.mode) UI.schedMode = p.mode === 'month' ? 'month' : 'week';
  if (p.sort) UI.csort = p.sort;
  if (p.tzx) S.settings.tz_extra = p.tzx;
  if (p.gsort) S.settings.grp_sort = p.gsort;
  if (p.mseg) UI.moneySeg = p.mseg as typeof UI.moneySeg;
  if (p.cseg) UI.clientSeg = p.cseg as typeof UI.clientSeg;
  if (p.zoom) { UI.zoom = p.zoom; UI.tlTop = 0; }
  if (p.tzoff) { UI.tzOff = {}; for (const z of p.tzoff.split(',')) if (z) UI.tzOff[z] = true; }
  if (p.day) UI.schedDay = addDays(S.today, Number(p.day));
  if (p.conf) {
    const b0 = S.sessions.find((x) => x.status === STATUS.PLAN);
    if (b0) {
      const a = { ...b0, id: 's9001', date: addDays(S.today, 3), start: '17:00', clientName: 'Наталья от Светы' };
      S.sessions.push(a, { ...a, id: 's9002', clientName: 'Татьяна от Нади' });
      S.conflicts = findConflicts(S.sessions, S.today);
    }
  }
  if (p.tab) setTab(p.tab);
  if (p.go) {
    const name = p.go === 'project' ? 'group' : p.go;
    go(name, p.id ? { id: await legacyUuid(KIND_OF[name] ?? name, p.id) } : p.client ? { clientId: await legacyUuid('client',
      p.client), date: addDays(S.today, Number(p.day || 1)) } : {});
  }
  render();
  window.scrollTo(0, 0);
  if (p.time && UI.book) {
    const ft = document.querySelector('[data-time]');
    UI.book.time = p.time === 'first' && ft ? Number(ft.getAttribute('data-time')) : Number(p.time);
    if (p.view) UI.book.tzView = p.view;
    render();
  }
  if (p.sheet === 'color') colorSheet({ title: 'Цвет клиента',
    sub: 'Так выделяются его сессии в расписании, точка в списках и событие в календаре Google.',
    current: p.color || 'green', kind: 'client', none: 'Как у всех', noneHint: 'синий · по умолчанию' }, () => {});
  if (p.sheet === 'zones') zonesSheet();
  if (p.sheet === 'bg') colorSheet({ title: 'Фон в светлой теме', current: p.color || '', kind: 'bglight',
    none: 'Как обычно' }, () => {});
  window.__shotDone = true;
}
